export default __webpack_public_path__ + "static/media/unpaid.cc27613e.svg";